export default __webpack_public_path__ + "static/media/Silver.924ab661.png";